import { render, staticRenderFns } from "./SelectGoodsDialog.vue?vue&type=template&id=0b5830cc&"
import script from "./SelectGoodsDialog.vue?vue&type=script&lang=js&"
export * from "./SelectGoodsDialog.vue?vue&type=script&lang=js&"
import style0 from "./SelectGoodsDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports